var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFewCloudsNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9478 22.8365C21.7993 22.8365 23.2982 21.3377 23.2982 19.4862C23.2982 17.6347 21.7993 16.1359 19.9478 16.1359C19.9363 16.1359 19.9248 16.1359 19.9133 16.1359C19.6182 13.4717 17.3527 11.394 14.6003 11.394C12.4268 11.394 10.56 12.6897 9.72433 14.5489C9.6975 14.5489 9.67067 14.545 9.64383 14.545C7.35533 14.545 5.5 16.4004 5.5 18.6889C5.5 20.9774 7.35533 22.8327 9.64383 22.8327",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0803 22.834C21.8702 22.7645 23.298 21.2934 23.298 19.4863C23.298 17.6348 21.7992 16.1359 19.9477 16.1359H19.9132C19.9028 16.0427 19.8901 15.9502 19.875 15.8584C20.2421 15.7206 20.6399 15.6453 21.0554 15.6453C22.7804 15.6453 24.2026 16.9486 24.3904 18.6276H24.4134C25.5749 18.6276 26.5179 19.5706 26.5179 20.7321C26.5179 21.8936 25.5749 22.8366 24.4134 22.8366L20.0803 22.834Z",
    fill: "#CAD1E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.203 16.1454C21.1302 16.2151 21.9517 16.6615 22.5149 17.3322C22.5151 17.3322 22.5153 17.3321 22.5155 17.332C21.9521 16.6613 21.1304 16.2149 20.203 16.1454ZM19.9142 16.1359H19.9134C19.7314 14.4931 18.8003 13.0734 17.4678 12.2262C17.8684 10.9396 18.8972 9.89382 20.2367 9.5086C20.3121 9.48628 20.393 9.5086 20.4461 9.56162C20.5019 9.61742 20.5215 9.69555 20.4991 9.77089C20.4042 10.1029 20.3539 10.4434 20.3539 10.7782C20.3539 12.79 21.9929 14.4279 24.006 14.4279C24.341 14.4279 24.6789 14.3805 25.0139 14.2828C25.0893 14.2605 25.1703 14.2828 25.2233 14.3358C25.2792 14.3916 25.2987 14.4697 25.2764 14.5451C25.0053 15.5003 24.398 16.2968 23.6068 16.8212C22.9911 16.1012 22.0768 15.6453 21.0565 15.6453C20.6409 15.6453 20.2432 15.7206 19.876 15.8584C19.8911 15.9502 19.9039 16.0427 19.9142 16.1359Z",
    fill: "url(#paint0_linear_4850_108373)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4850_108373",
    x1: 18.6123,
    y1: 16.1835,
    x2: 24.1491,
    y2: 10.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB63A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CC3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewCloudsNight);
export default __webpack_public_path__ + "static/media/few_clouds_night.49d46de56c13991c48fda8dfd8c84edb.svg";
export { ForwardRef as ReactComponent };